import { ButtonGroup, Popper } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import Autocomplete from "../Autocomplete";
import Button from "../Button";
import TextField from "../TextField";
import styles from "./index.module.scss";

import DeleteIcon from "@material-ui/icons/Delete";
import { useTranslation } from "react-i18next";

export default function AddCoachee({
  coacheeList,
  filterOptions,
  addCampaignCoachee,
  deleteCampaignCoachee,
  addAllCampaignCoachee,
  deleteAllCampaignCoachee,
  campaignId,
  userLevelId,
}) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();
  const [selectedCoachee, setSelectedCoachee] = useState(null);
  const [campaignCoachee, setCampaignCoachee] = useState(coacheeList);
  const [allCoachees, setAllCoachees] = useState([]);
  // const [filteredCoacheeList, setFilteredCoacheeList] = useState(
  //   allCoachees ? allCoachees : []
  // );
  // console.log(coacheeList, "status check");
  //for add all
  const [open, setOpen] = useState(false);
  const timer = useRef(-1);

  const setOpenByTimer = isOpen => {
    clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      setOpen(isOpen);
    }, 200);
  };

  useEffect(() => {
    setCampaignCoachee(coacheeList);
  }, [coacheeList]);

  useEffect(() => {
    getAllCoachee();
  }, [campaignId]);

  async function getAllCoachee() {
    // const campaignID = selectedCampaign.campaign_id;
    const response = await apiRequest.post(`/api/getAllCoachees`, {
      campaign_ids: [campaignId],
      u_levelid: userLevelId,
    });
    if (response.status === 200) {
      const data = response.data.data;
      setAllCoachees(data);
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  }
  const addCoachees = coachee => {
    const isExist = campaignCoachee.filter(item => {
      return item.employee_id === coachee.employee_id;
    });
    if (isExist.length > 0) {
      addNotification(t("error.selectedCoacheeIsAlreadyBeenAdded"), "error");
    } else {
      addCampaignCoachee(coachee);
    }
  };

  const AddAllButtons = function (props) {
    const addAllClick = e => {
      clearTimeout(timer.current);
      setOpen(false);
      addAllCampaignCoachee(allCoachees);
    };
    const clearClick = e => {
      clearTimeout(timer.current);
      deleteAllCampaignCoachee();
      setOpen(false);
    };
    return (
      <Popper
        {...props}
        style={{ backgroundColor: "#fff", textAlign: "center" }}
      >
        <ButtonGroup color="primary" aria-label="outlined primary button group">
          <Button color="primary" onClick={addAllClick}>
            Add All
          </Button>
          <Button color="primary" onClick={clearClick}>
            Clear
          </Button>
        </ButtonGroup>
        {props.children}
      </Popper>
    );
  };

  return (
    <>
      <div className={styles.coacheeSelection}>
        <Autocomplete
          id="coach"
          value={selectedCoachee}
          PopperComponent={AddAllButtons}
          onChange={(event, newValue) => {
            setSelectedCoachee(newValue);
          }}
          filterOptions={filterOptions}
          options={allCoachees}
          getOptionLabel={option => option.u_fullname}
          style={{ width: 280 }}
          renderInput={params => (
            <TextField
              {...params}
              placeholder="Type a name or Employee ID"
              variant="outlined"
            />
          )}
          onOpen={e => {
            setOpenByTimer(true);
          }}
          onClose={(obj, reason) => {
            setOpenByTimer(false);
          }}
          open={open}
        />
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          style={{ marginLeft: "6px" }}
          onClick={() => {
            addCoachees(selectedCoachee);
          }}
        >
          {t("userManagement.add")}
        </Button>
      </div>
      {campaignCoachee && campaignCoachee.length > 0 && (
        <table className={styles.coachTable}>
          <thead>
            <tr>
              <th width="50%">{t("userManagement.name")}</th>
              <th width="25%">{t("userManagement.id")}</th>
              <th width="20%">{t("userManagement.role")}</th>
              <th width="50%">{t("userManagement.status")}</th>
              <th width="5%"></th>
            </tr>
          </thead>
          <tbody>
            {campaignCoachee.map((coachee, eindex) => (
              <tr key={eindex}>
                {coachee && (
                  <>
                    <td>{coachee.u_fullname}</td>
                    <td>{coachee.employee_id}</td>
                    <td>{coachee.u_role_value}</td>
                    <td
                      className={
                        coachee.status === "Active"
                          ? styles.statusActive
                          : styles.statusInactive
                      }
                    >
                      {coachee.status}
                    </td>
                    <td>
                      <DeleteIcon
                        style={{
                          color: "#9E9E9E",
                          fontSize: 16,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          deleteCampaignCoachee(coachee);
                        }}
                      />
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}